<mat-drawer-container class="conteiner-desktop">

    <mat-drawer disableClose #drawer [ngClass]="{'sidenav-desktop': !isPhone}"  class="" [mode]="isPhone? 'push': 'side'" [opened]="!isPhone">
        
        <div  [ngClass]="{'navigation-list-desktop': !isPhone}" class="sidebar-container">

            <img
                *ngIf="!isPhone"
                (click)="goToHomePage()"
                src="../../../../assets/images/logo/logo-hudlygo.png"
                alt="Agilweb logo image"
                class="logo">

            <mat-nav-list role="navigation" style="margin-top: 30px;">   
                <mat-list-item  routerLink="/admin" [routerLinkActive]="['is-active']" [routerLinkActiveOptions]="{ exact: true }">
                    <mat-icon mat-list-icon class="material-icons-round" style="font-size: 1.4rem; margin-right: -10px;"> person </mat-icon>
                    <span mat-line style="font-size: 15px;"> Contas </span>
                </mat-list-item>

                <mat-list-item  routerLink="/admin/pricing" [routerLinkActive]="['is-active']">
                    <mat-icon mat-list-icon class="material-icons-round" style="font-size: 1.4rem; margin-right: -10px;"> attach_money </mat-icon>
                    <span mat-line style="font-size: 15px;"> Tabela de Produtos </span>
                </mat-list-item>

                <mat-list-item  routerLink="/admin/seguros" [routerLinkActive]="['is-active']">
                    <mat-icon mat-list-icon class="material-icons-round" style="font-size: 1.4rem; margin-right: -10px;"> fact_check </mat-icon>
                    <span mat-line style="font-size: 15px;"> Análise de Seguros </span>
                    <span class="pending-badge" *ngIf="pendingLinksCount">{{ pendingLinksCount }}</span>
                </mat-list-item>

                <mat-list-item (click)="handleLogout()" class="last-item" >
                    <mat-icon mat-list-icon class="material-icons-round" style="font-size: 1.4rem; margin-right: -10px;">logout</mat-icon>
                    <span mat-line style="font-size: 15px;">Sair</span>
                </mat-list-item>
                 
            </mat-nav-list>

        </div>

    </mat-drawer>

    <mat-drawer-content [ngClass]="{'desktop-content': !isPhone,   'phone-content' : isPhone}" >
        <ng-content></ng-content>

    </mat-drawer-content>
</mat-drawer-container>